import React from "react";
import { Row, Col } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";
function OrderDetails({ data }) {
  const { /*t, */i18n: { language } } = useTranslation();// Required (from the useTranslation import, via react-i18next) to make the translations work from within this component.
  const { orderDetails: { deliveryCity, deliveryProvince, lastUpdated, lastUpdatedTimeZone, reference } } = data;

  let options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true
  };
  // Translate using the browser's localization logic, as it does french better
  const generatedAtDate = new Intl.DateTimeFormat(language.substring (0, 2), options).format(new Date(lastUpdated));


  return (
    <Row className="ms-0 me-0">
      <Col xs={12} lg={5}>
        <p>
          <Trans i18nKey="OrderDetails.destination">
            Destination City: <b>{{ deliveryCity }}, {{ deliveryProvince }}</b>
          </Trans>
        </p>
        <p>
          {/*<Trans i18nKey="OrderDetails.lastUpdated">
            Last updated: <b>{{ lastUpdated }} {{ lastUpdatedTimeZone }}</b>
          </Trans> */}
          <Trans i18nKey="OrderDetails.lastUpdated">Last updated:</Trans>&nbsp;<b>{generatedAtDate} {lastUpdatedTimeZone }</b>
        </p>
      </Col>
      <Col xs={12} lg={4}>
        <p>
          <Trans i18nKey="OrderDetails.reference">
            Reference Number: <b>{{ reference }}</b>
          </Trans>
        </p>
      </Col>
    </Row>
  );
}

export default OrderDetails;
